module.exports = __webpack_public_path__ + "img/cloud-snow-sun.a17eb877.svg";